import React from 'react';
import { CreditCard, ExternalLink, Check } from 'lucide-react';
import { digitalCardProduct } from '../../data/servicesData';

const DigitalCardProduct = () => (
  <section
    id="digital-business-card"
    data-testid="digital-card-product"
    className="scroll-mt-32 rounded-2xl bg-gray-900 text-white p-6 sm:p-10 shadow-2xl relative overflow-hidden"
  >
    <div className="absolute -right-20 -top-20 w-72 h-72 rounded-full opacity-20" style={{ backgroundColor: '#D97904' }} />
    <div className="relative grid lg:grid-cols-2 gap-8 items-center">
      <div>
        <span className="inline-block text-xs font-bold uppercase tracking-widest px-3 py-1 rounded-full mb-4" style={{ backgroundColor: '#D97904' }}>
          Featured Product
        </span>
        <div className="flex items-center gap-3 mb-3">
          <CreditCard className="w-8 h-8" style={{ color: '#FF9900' }} />
          <h2 className="text-2xl sm:text-3xl font-bold" style={{ fontFamily: 'var(--font-serif)' }}>
            {digitalCardProduct.title}
          </h2>
        </div>
        <p className="font-semibold mb-3" style={{ color: '#FF9900' }}>{digitalCardProduct.tagline}</p>
        <p className="text-gray-300 leading-relaxed mb-6">{digitalCardProduct.description}</p>
        <a
          href={digitalCardProduct.url}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="digital-card-link"
          className="inline-flex items-center gap-2 text-white font-bold px-6 py-3 rounded-full hover:scale-105 transition-transform duration-300"
          style={{ background: 'linear-gradient(135deg, #D97904 0%, #FF9900 100%)' }}
        >
          Get Your Digital Card at card.iwurks360.com
          <ExternalLink className="w-4 h-4" />
        </a>
      </div>
      <ul className="space-y-3">
        {digitalCardProduct.features.map((f) => (
          <li key={f} className="flex items-start gap-3 bg-white/5 backdrop-blur-sm rounded-lg p-4 border border-white/10">
            <Check className="w-5 h-5 mt-0.5 flex-shrink-0" style={{ color: '#FF9900' }} />
            <span className="text-gray-100">{f}</span>
          </li>
        ))}
      </ul>
    </div>
  </section>
);

export default DigitalCardProduct;
